import React from 'react';
import { useTranslation } from 'react-i18next';
import HelpIcon from './HelpIcon';

import { emoText } from '../shell/EmojiIcons';
// THE table toolbar: sits on the page background directly above a table (no card, no border, like the Sales Orders table).
// Left: optional small title + plain-text count (meta). Right (fixed order): page selectors (Segmented...), then the Columns gear, then any export.
export default function TableToolbar({ title, help, meta, children, testid }) {
  return (
    <div className="tbar" data-testid={testid}>
      <div className="tbar-l">
        {title != null && <span className="tbar-title">{emoText(title)}{help && <HelpIcon helpKey={help} />}</span>}
        {meta != null && <span className="tbl-meta">{meta}</span>}
      </div>
      <div className="tbar-r">{children}</div>
    </div>
  );
}

// Label that precedes a selector inside the toolbar (e.g. "Avg sold window").
export const ToolbarLabel = ({ children, help }) => <span className="tbar-lab">{children}{help && <HelpIcon helpKey={help} />}</span>;

// The shared segmented control (styleguide: Controls). options: [{ key, label, testid?, title?, disabled? }] or [key]. The active one is aria-pressed.
export function Segmented({ options, value, onChange, label, testid, disabled }) {
  return (
    <span className="seg" role="group" aria-label={label} data-testid={testid}>
      {options.map((o) => {
        const { key, label: text, testid: tid, title, disabled: off } = typeof o === 'object' ? o : { key: o, label: o };
        return <button type="button" key={key} className={value === key ? 'on' : undefined} aria-pressed={value === key} data-testid={tid} title={title} disabled={disabled || off} onClick={() => onChange(key)}>{text}</button>;
      })}
    </span>
  );
}

// ONE "Show inactive" control for every filter bar: a labelled checkbox (owner 2026-10-09 reversed the pill). Callers place it LAST in the filter row.
// 34px row box, centred like the other facets; alignSelf:flex-end keeps it on the control row when siblings carry a label above.
const SHOW_INACTIVE_STYLE = { display: 'inline-flex', alignItems: 'center', gap: 6, height: 34, margin: 0, alignSelf: 'flex-end', fontSize: 13, lineHeight: 1, color: 'var(--ink)', cursor: 'pointer', whiteSpace: 'nowrap' };
export function ShowInactiveToggle({ on, onChange, title, testid }) {
  const { t } = useTranslation('common');
  return (
    <label className="show-inactive" style={SHOW_INACTIVE_STYLE} title={title}>
      <input type="checkbox" data-testid={testid} checked={!!on} onChange={e => onChange(e.target.checked)} style={{ margin: 0 }} />
      {t('showInactive')}
    </label>
  );
}
